import {RubricModel} from '../common/types';

export class RubricChangedEvent {
	public rubricModel: RubricModel;
	public contentAreaName: string;
}
